import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import {
  selectMultipleChoiceOption,
  getCampaignElementById,
} from '@src/redux/modules/campaignLandingPage';

const VpMultipleChoice = ({ qid, element, _selectMultipleChoiceOption }) => {
  const { description, label, allowedValues, required, value } = element || {};

  const options = useMemo(() => {
    const source = Array.isArray(allowedValues) && allowedValues.length
      ? allowedValues
      : (description ? description.split(',') : []);

    return source
      .map((option) => String(option).trim())
      .filter(Boolean);
  }, [allowedValues, description]);

  const selectedValue = options.includes(value) ? value : null;

  const handleChange = useCallback(
    (event, newValue) => {
      _selectMultipleChoiceOption(qid, newValue || '');
    },
    [qid, _selectMultipleChoiceOption]
  );

  const filterOptions = useCallback((optionsList, { inputValue }) => {
    const searchTerm = inputValue.toLowerCase().trim();
    if (!searchTerm) return optionsList;
    return optionsList.filter((option) => option.toLowerCase().includes(searchTerm));
  }, []);

  return (
    <Stack sx={{ maxWidth: '600px', my: '10px', fontFamily: 'Roboto' }}>
      <Box>
        <FormLabel
          sx={{
            fontWeight: 700,
            mb: '10px',
            color: 'black',
            fontSize: '14px',
          }}
        >
          {label}
        </FormLabel>
        {required && (
          <span style={{ display: 'inline-block', color: 'var(--primary-600)', marginLeft: '4px' }}>
            *
          </span>
        )}
      </Box>

      <Autocomplete
        id={`multiple-choice-${qid}`}
        options={options}
        value={selectedValue}
        onChange={handleChange}
        filterOptions={filterOptions}
        noOptionsText="No options found"
        clearText="Clear"
        openText="Open"
        closeText="Close"
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        autoHighlight
        ListboxProps={{
          style: { maxHeight: 300 }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Type to search..."
            variant="outlined"
            size="small"
            fullWidth
          />
        )}
      />
    </Stack>
  );
};

VpMultipleChoice.propTypes = {
  qid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  element: PropTypes.object.isRequired,
  _selectMultipleChoiceOption: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  element: getCampaignElementById(state, ownProps.qid),
});

const mapDispatchToProps = {
  _selectMultipleChoiceOption: selectMultipleChoiceOption,
};

export default connect(mapStateToProps, mapDispatchToProps)(VpMultipleChoice);



// WEBPACK FOOTER //
// ./src/vp-ui/components/MultipleChoice/MultipleChoice.jsx